import React from 'react'
import { formatNumber } from 'utils/helpers'

interface InfluencerStatsProps {
    average_views: string,
    engagement_color: string,
    engagement_score: string,
    authenticity_color: string,
    authenticity_score: string,
    requirement_match_color: string,
    requirement_match: string,
    followers_count: number
}

const InfluencerStats: React.FC<InfluencerStatsProps> = ({ average_views, engagement_color, engagement_score, authenticity_color, authenticity_score, requirement_match, requirement_match_color, followers_count }) => {
    return (
        <React.Fragment>
            <div className="d-flex border-bottom-1 justify-content-between align-items-center">
                <div className="stat-card border-right-1 w-100">
                    <span className="stat-value">{formatNumber(followers_count)}</span>
                    <span className="stat-label">Followers</span>
                </div>
                {/* <div className="stat-card w-100">
                    <span className="stat-value">{gender_name}</span>
                    <span className="stat-label">Gender</span>
                </div> */}
                 <div className="stat-card w-100">
                    <span className={`stat-value text-${engagement_color}`}>{engagement_score ?? 'NA'}</span>
                    <span className="stat-label">Engg Score</span>
                </div>
            </div>
            {/* <div className="d-flex border-bottom-1 justify-content-between align-items-center">
                <div className="stat-card border-right-1 w-100">
                    <span className={`stat-value text-${engagement_color}`}>{engagement_score ?? 'NA'}</span>
                    <span className="stat-label">Engg Score</span>
                </div>
                <div className="stat-card w-100">
                    <span className={`stat-value text-${authenticity_color}`}>{authenticity_score ? `${authenticity_score}%` : 'NA'}</span>
                    <span className="stat-label">Authenticity</span>
                </div>
            </div> */}
            <div className="d-flex border-bottom-1 justify-content-between align-items-center">
                <div className="stat-card border-right-1 w-100">
                    <span className={`stat-value text-${requirement_match_color}`}>{requirement_match}%</span>
                    <span className="stat-label">Criteria Match</span>
                </div>
                <div className="stat-card w-100">
                    <span className="stat-value">{average_views ? formatNumber(parseInt(average_views)) : 'NA'}</span>
                    <span className="stat-label">Average Views</span>
                </div>
            </div>
        </React.Fragment>
    )
}

export default InfluencerStats